<template>
  <div :class="classes"></div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-dummy",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-dummy {
}
</style>
